import React, { useEffect } from "react";
import { Formik, Form, useFormikContext } from "formik";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import LinearProgress from "@mui/material/LinearProgress";
import Typography from "@mui/material/Typography";
import SearchIcon from "@mui/icons-material/Search";
import ScannerInput from "../../../../../form/ScannerInput";

function FormSync({ setSearchCode }) {
  const { values } = useFormikContext();
  useEffect(() => {
    setSearchCode(values.code);
  }, [values.code, setSearchCode]);
  return null;
}

export default function SearchAssetView({
  searchCode,
  setSearchCode,
  handleSearch,
  searchLoading,
  searchError,
}) {
  const handleSubmit = (values) => {
    if (values.code.trim()) {
      handleSearch(values.code);
    }
  };

  const handleDetected = (code) => {
    if (code.trim()) {
      handleSearch(code);
    }
  };

  return (
    <Box mt={2}>
      <Formik initialValues={{ code: searchCode }} onSubmit={handleSubmit} enableReinitialize>
        {({ values }) => (
          <Form>
            <FormSync setSearchCode={setSearchCode} />
            <ScannerInput
              autoFocus
              size="small"
              name="code"
              label="What Would You Like to Move?"
              showNAButton={false}
              onDetected={handleDetected}
            />
          </Form>
        )}
      </Formik>
      {searchLoading && (
        <Box mt={2}>
          <LinearProgress />
        </Box>
      )}
      {!!searchError && (
        <Typography mt={1} variant="body2" color="error.main">
          {searchError}
        </Typography>
      )}
    </Box>
  );
}
